import { render, staticRenderFns } from "./IntroductionReference.vue?vue&type=template&id=b34eee84&scoped=true&"
import script from "./IntroductionReference.vue?vue&type=script&lang=js&"
export * from "./IntroductionReference.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionReference.vue?vue&type=style&index=0&id=b34eee84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34eee84",
  null
  
)

export default component.exports